module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main